import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';
import { Colors } from '../../../themes/colors';

export const DualIcon: React.FC<IconProps> = ({
  size = 16,
  color = Colors.role.textStrong,
  style,
    ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    overflow="visible"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
    style={[{ overflow: 'visible' } as const, style] as unknown}
  >
    <Path d="M0.771431 4.65969H17.2286M17.2286 4.65969L13.1143 0.545426M17.2286 4.65969L13.1143 8.77403M17.2286 12.8883H0.771431M0.771431 12.8883L4.88573 8.77407M0.771431 12.8883L4.88573 17.0027" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

DualIcon.displayName = 'DualIcon';
